import { createRouter, createWebHistory } from '@ionic/vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { authGuard, adminGuard } from './guards'
import MainLayout from '@/components/MainLayout.vue';


// Routes with MainLayout (tab navigation)
const tabRoutes: Array<RouteRecordRaw> = [
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/worker/Dashboard.vue'),
        beforeEnter: authGuard,
        meta: { requiresAuth: true, title: 'Dashboard' }
    },
    {
        path: '/history',
        name: 'History',
        component: () => import('@/views/worker/HistoryView.vue'),
        beforeEnter: authGuard,
        meta: { requiresAuth: true, title: 'History' }
    },
    {
        path: '/settings',
        name: 'Settings',
        component: () => import('@/views/worker/SettingsView.vue'),
        beforeEnter: authGuard,
        meta: { requiresAuth: true, title: 'Settings' }
    },
    {
        path: '/vacation',
        name: 'Vacation',
        component: () => import('@/views/worker/VacationView.vue'),
        beforeEnter: authGuard,
        meta: { requiresAuth: true, title: 'Vacation' }
    }
]

// Full-screen routes without tabs
const fullScreenRoutes: Array<RouteRecordRaw> = [
    {
        path: '/profile-assignment',
        name: 'ProfileAssignment',
        component: () => import('@/views/worker/ProfileAssignment.vue'),
        meta: { requiresAuth: false, title: 'Assign Worker' }
    },
    {
        path: '/scanner',
        name: 'Scanner',
        component: () => import('@/views/worker/ScannerView.vue'),
        beforeEnter: authGuard,
        meta: { requiresAuth: true, title: 'Scanner' }
    },
    {
        path: '/ble-checkin',
        name: 'BleCheckin',
        component: () => import('@/views/worker/BleCheckinView.vue'),
        beforeEnter: authGuard,
        meta: { requiresAuth: true, title: 'Bluetooth Check-in' }
    },
    {
        path: '/admin',
        name: 'AdminPanel',
        component: () => import('@/views/admin/AdminPanel.vue'),
        beforeEnter: adminGuard,
        meta: { requiresAuth: true, requiresAdmin: true, title: 'Admin Panel' }
    },
    {
        path: '/admin/manual-records',
        name: 'ManualRecordManagement',
        component: () => import('@/views/admin/ManualRecordManagement.vue'),
        beforeEnter: adminGuard,
        meta: { requiresAuth: true, requiresAdmin: true, title: 'Manual Record Management' }
    },
    {
        path: '/admin/logs',
        name: 'LogsPage',
        component: () => import('@/views/admin/LogsPage.vue'),
        beforeEnter: adminGuard,
        meta: { requiresAuth: true, requiresAdmin: true, title: 'Logs' }
    }
]

// Main routes structure - Ionic best practice with nested tabs
const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        redirect: '/dashboard'
    },
    {
        path: '/',
        component: MainLayout,
        children: tabRoutes
    },
    ...fullScreenRoutes
]

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
})

export default router
